import { lazy } from 'react'

import { authRoles } from '../../../auth/authRoles'
import Loadable from '../../base/components/Template/Loadable/Loadable'
import { configuracionRoutesMap } from './ConfiguracionRoutesMap'

const AppFacturaDetalleExtra = Loadable(
  lazy(() => import('./view/FacturaDetalleExtra/FacturaDetalleExtra')),
)
const AppParametroSistema = Loadable(
  lazy(() => import('./view/ParametrosSistema/ParametroSistema')),
)
const AppMisMetodosPago = Loadable(
  lazy(() => import('./view/MisMetodosPago/MisMetodosPago')),
)

const configuracionRoutes = [
  {
    path: configuracionRoutesMap.detalleExtra.path,
    element: <AppFacturaDetalleExtra />,
    auth: authRoles.admin,
  },
  {
    path: configuracionRoutesMap.parametrosSistema.path,
    element: <AppParametroSistema />,
    auth: authRoles.admin,
  },
  {
    path: configuracionRoutesMap.misMetodosPago.path,
    element: <AppMisMetodosPago />,
    auth: authRoles.admin,
  },
]

export default configuracionRoutes
